/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ScaleEnum {
    STANDARD = 'STANDARD',
    THOUSANDS = 'THOUSANDS',
    MILLIONS = 'MILLIONS',
}
